import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  error: false,
  errorMessage: "",
  errorMessageData: "",
  items: [],
};

export const viewRedeemableSerialSlice = createSlice({
  name: "viewRedeemableSerial",
  initialState,
  reducers: {
    redeemableSerialInprogress: () => {
      return {
        ...initialState,
        loading: true,
      };
    },

    redeemableSerialProcessed: (state, { payload }) => {
      return {
        ...initialState,
        ...payload,
      };
    },

    redeemableSerialCompleted: () => {
      return initialState;
    },
  },
});

export const {
  redeemableSerialInprogress,
  redeemableSerialProcessed,
  redeemableSerialCompleted,
} = viewRedeemableSerialSlice.actions;

export default viewRedeemableSerialSlice.reducer;
